// defang - IOC defang/refang so pasted IOCs don't auto-link into clickable landmines.
// Standard convention: `.`→`[.]`, `://`→`[:]//`, `@`→`[@]`; refang reverses it.

const REPLACEMENTS_DEFANG: [RegExp, string][] = [
  [/:\/\//g, '[:]//'],
  [/\./g, '[.]'],
  [/@/g, '[@]'],
];

const REPLACEMENTS_REFANG: [RegExp, string][] = [
  [/\[:\]\/\//g, '://'],
  [/\[\.\]/g, '.'],
  [/\[@\]/g, '@'],
];

// Defang URLs/IPs/domains/emails so they're safe to paste anywhere.
export function defang(value: string): string {
  let out = value;
  for (const [re, rep] of REPLACEMENTS_DEFANG) {
    out = out.replace(re, rep);
  }
  return out;
}

export function refang(value: string): string {
  let out = value;
  for (const [re, rep] of REPLACEMENTS_REFANG) {
    out = out.replace(re, rep);
  }
  return out;
}

// Only network-style kinds auto-link; defanging hashes/paths/keys is noise.
//
// `host` is here because it is the same thing under another name - a domain or
// an address, as the spamhaus job spells it. Its absence was an omission rather
// than a decision, and it meant the defang toggle silently did nothing for the
// most common observable kind that stage produces.
const NETWORK_KINDS = new Set([
  'url', 'domain', 'host', 'hostname', 'ipv4', 'ipv6', 'ip', 'email',
]);

export function isNetworkIocKind(kind: string): boolean {
  return NETWORK_KINDS.has(kind.toLowerCase());
}

// Convenience: defang value if its kind is network-style, else
// pass through untouched.
export function maybeDefang(value: string, kind: string, on: boolean): string {
  if (!on) return value;
  if (!isNetworkIocKind(kind)) return value;
  return defang(value);
}

/**
 * Whether the report the reader has open is defanged.
 *
 * Defanged by DEFAULT; `?defang=off` is the reader who needs live values. The
 * rule lives here rather than at each caller because two parts of the report
 * page read it from the URL at different depths — the letterhead is built
 * before the tab state exists — and two spellings of "off" is how one of them
 * ends up showing a live address under a defanged report.
 */
export function isDefanged(params: URLSearchParams): boolean {
  return params.get('defang') !== 'off';
}
